module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_6",
      "title": "Foreword by Gabe Lyons"
    }
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    staticClass: "img10",
    attrs: {
      "alt": "dingbat.jpg",
      "src": "Images/dingbat.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "first-words"
  }, [_vm._v("Until now, few books")]), _vm._v(" have articulately expressed a grounded, holistic, nuanced, intellectually honest and loving approach to sexuality. Debra places this conversation in its proper place, moving us away from the “gay issue” to properly deal with the broader questions it raises around our sexuality, intimacy and the church’s role in sustaining relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Debra explicitly shares her personal journey. Writing in a nonprescriptive and nonjudgmental way, Debra rouses our curiosity to consider a deeper way to think about our sexuality. In a culture obsessed with sexual expression, orientations and gender identity, she helps properly order the role these things should play in our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Debra’s humility and candor make this topic approachable, even fun. I don’t know that I’ve read a book with more appropriate references to orgasm, with raw honesty about our sexual appetites and their relationship to our spirituality. At first you might feel awkward, but then you’ll find it refreshing.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But more than Debra’s authentic writing style, her curation of knowledge and depth of experience on the topics at hand are a godsend in our age. We couldn’t have a better guide than Debra Hirsch leading us forward.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Conversations about sexuality can feel risky. Reflecting on the dynamics at play, I picture a treacherous path winding up the face of a rocky, stone-faced cliff. Our self-preserving questions and a fear of the unknown may hold us back. We wonder")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("What if I take the wrong step?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("What if this costs me my reputation?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("What if I fail?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("These questions and fears understandably keep many people flat-footed on the ground. We’ve watched the casualties of those who dared to go before us. We’ve learned from their mistakes that every step matters, placing our grip on the wrong protruding rock can result in utter devastation, and the risks are enormous. Though the path is narrow, deep down we know it’s one we must ascend. Faithfulness demands we engage the issue of our day with the weight and seriousness it requires.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("While some tire of the conversation, I urge you to press on. We sit at the beginning of a moment that will not soon go away. Make no mistake, you will be asked the question. And because you invested the time to read this book, your answer will be full of grace, mercy, truth and clarity—something your friends and family long for, but few have found. I pray you find it in the pages of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("Gabe Lyons")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa4b8c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/foreword.vue
// module id = 69
// module chunks = 0